import { ResourceProps } from "react-admin";
import { AdminUsersList } from "./components";

export const adminUsersResource: Omit<ResourceProps, "name"> = {
  list: AdminUsersList,
};
